<template lang="pug">
.post-tags
  .post-tags__wrapper
    .post-tags__tag.--underline-effect(
      v-for="tag in tagsList"
      :key="tag"
    )
      span.symbol #
      span.first-char {{ tag.substring(0, 1) }}
      span {{ tag.substring(1) }}
    .post-tags__more.post-tags__tag.--underline-effect(
      title="Show All"
      v-if="hasMore && !showAll"
      @click="showAll = true"
    )
      span.symbol &plus;
      span.more-count {{ tags.length - maxShowDefault }}
</template>

<script>
export default {
  name: 'post-tags',
  props: {
    tags: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      maxShowDefault: 4,
      showAll: false,
    }
  },
  computed: {
    hasMore() {
      return this.tags.length > this.maxShowDefault
    },
    tagsList() {
      return this.hasMore && !this.showAll
        ? this.tags.slice(0, this.maxShowDefault)
        : this.tags
    },
  },
}
</script>

<style lang="sass">
.post-tags
  padding: 0.5rem
  margin: -0.5rem
  margin-bottom: 0.5rem

.post-tags__wrapper
  margin-left: -1rem
  margin-bottom: -1rem

.post-tags__tag
  display: inline-block
  margin-left: 1rem
  margin-bottom: 1rem
  padding: 0.25rem 0.5rem
  padding-right: calc(0.5rem + 0.333rem)
  border: 2px solid var(--base-color)
  border-radius: 5px
  font-variant: all-small-caps;
  font-size: 0.8rem
  background-color: var(--base-color)
  color: white
  cursor: pointer

  &.--underline-effect
    background-image: linear-gradient(white, white)
    background-size: 100% 0

    &:hover,
    &:active
      background-size: 100% 100%
      color: var(--base-color)
  
  &.post-tags__more
    background-color: white
    color: var(--base-color)
    font-variant: none

    &.--underline-effect
      background-position: top left
      background-image: linear-gradient(var(--base-color), var(--base-color))
      
      &:hover,
      &:active
        color: white

  .symbol
    padding: 0 0.333rem

  .first-char
    text-transform: uppercase;
    font-variant: none;
</style>
